import { createApp } from "vue";

const app = createApp({});

export default app;